import React from 'react';
import './HeroSection.css';
import Home from '../../pages/Home/Home';
import Facilities from '../../pages/Home/Facilities';
import PrinciMessage from '../../pages/Home/PrinciMessage';
import TopperBanner from '../../pages/Home/TopperBanner';
import BannerComponent from '../../pages/Home/BannerComponent';
import ImageCarousel from './ImageCarousel';

import image1 from '../../images/1.jpg';
import image2 from '../../images/2.jpg';
import image3 from '../../images/3.jpg';
import image4 from '../../images/4.jpg';
import image5 from '../../images/5.jpg';
import image6 from '../../images/6.jpg';
import image7 from '../../images/7.jpg';
import image8 from '../../images/8.jpg';
import image9 from '../../images/9.jpg';

const images = [image1, image2, image3, image4, image5, image6, image7, image8, image9];

const HeroSection = () => {
  return (
    <div className="hero-section">
      <section className="intro-section">
        <Home />
      </section>

      <section className="carousel-wrapper">
        <ImageCarousel images={images} />
      </section>

      <section className="section-wrapper">
        <PrinciMessage />
      </section>

      <section className="section-wrapper">
        <Facilities />
      </section>

      <section className="banners-wrapper">
        <BannerComponent />
      </section>

      <section className="topper-banner-wrapper">
  <TopperBanner />
</section>

    </div>
  );
};

export default HeroSection;
